import { useTranslation } from 'react-i18next';
import { Modal } from '../common/Modal';
import type { DashboardAuditLogEntry } from '../../types/dashboard';

type DashboardAuditLogModalProps = {
  open: boolean;
  fileRef: string;
  entries: DashboardAuditLogEntry[];
  loading: boolean;
  onClose: () => void;
};

function AuditBadge({ entry }: { entry: DashboardAuditLogEntry }) {
  return <span className={`dash-audit-badge dash-audit-badge--${entry.badgeVariant}`}>{entry.action}</span>;
}

export function DashboardAuditLogModal({ open, fileRef, entries, loading, onClose }: DashboardAuditLogModalProps) {
  const { t } = useTranslation();

  return (
    <Modal open={open} onClose={onClose} title={t('allocationDashboard.auditModalTitle')} boxClassName="dash-audit-modal">
      <div style={{ marginTop: -8, marginBottom: 12 }}>
        <span className="dash-audit-ref">{fileRef}</span>
      </div>
        <table className="dt" style={{ minWidth: 0 }}>
          <thead>
            <tr>
              <th style={{ width: 170 }}>{t('allocationDashboard.auditColDateTime')}</th>
              <th>{t('allocationDashboard.auditColActivityBy')}</th>
              <th>{t('allocationDashboard.auditColAction')}</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={3}>{t('common.loading')}</td>
              </tr>
            ) : entries.length === 0 ? (
              <tr>
                <td colSpan={3}>{t('allocationDashboard.noAuditLogs')}</td>
              </tr>
            ) : (
              entries.map((entry, idx) => (
                <tr key={`${entry.date}-${entry.time}-${idx}`}>
                  <td>
                    <div style={{ fontSize: 13, fontWeight: 600 }}>{entry.date}</div>
                    <div style={{ fontSize: 12, color: 'var(--t3)', marginTop: 2 }}>{entry.time}</div>
                  </td>
                  <td>
                    <div className="dash-audit-person">
                      <div className="dash-audit-avatar" aria-hidden="true">
                        {entry.isSystem ? (
                          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
                          </svg>
                        ) : (
                          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                            <circle cx="12" cy="7" r="4" />
                          </svg>
                        )}
                      </div>
                      <div>
                        <div style={{ fontSize: 13, fontWeight: 600 }}>{entry.name}</div>
                        <div style={{ fontSize: 12, color: 'var(--t3)' }}>{entry.role}</div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <AuditBadge entry={entry} />
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
    </Modal>
  );
}